import { render, staticRenderFns } from "./line-default.md?vue&type=template&id=283cc3fa&"
import script from "./line-default.md?vue&type=script&lang=js&"
export * from "./line-default.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283cc3fa')) {
      api.createRecord('283cc3fa', component.options)
    } else {
      api.reload('283cc3fa', component.options)
    }
    module.hot.accept("./line-default.md?vue&type=template&id=283cc3fa&", function () {
      api.rerender('283cc3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Line/line-default.md"
export default component.exports